module.exports = __webpack_public_path__ + "media/images/app/homepage/couture/doves-820f6958da2737f39b9b55a5f52d35dc.webp";